import { cx } from '@platform/core/lib/cx';
import type { ISwitchProps } from './ISwitchProps';

/** Перемикач увімк./вимк. (UIUX/controls/switch): 42×24, повзунок 20px; увімкнено — --accent, вимкнено — --line2; role=switch. */
export function Switch({ checked, onChange, label, disabled = false }: ISwitchProps) {
  return (
    <button type="button" role="switch" aria-checked={checked} aria-label={label} title={label} disabled={disabled}
      className={cx('switch', checked && 'is-on')} onClick={() => onChange(!checked)}>
      <span className="switch__knob" />
    </button>
  );
}
